<template lang="html">
  <div class="">
    <div v-if="value" class="d-flex align-center">
      <div class="">
        {{visible ? value : hideCenter(value)}}
      </div>
      <div class="">
        <v-btn
          text
          icon
          class="ml-2"
          @click="visible = !visible"
        >
        <v-icon v-if="visible">mdi-eye-off-outline</v-icon>
        <v-icon v-else>mdi-eye-outline</v-icon>
      </v-btn>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {}
  },
  watch: {
    value() {
      this.visible = false;
    }
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    hideCenter(v) {
      return (v || '').slice(0, 2) + '***' + (v || '').slice(-1);
    }
  }
}
</script>

<style lang="css" scoped>
</style>
